// @flow
export const HybridTiers = {
  tier1: 'tier1',
  tier2: 'tier2',
  tier3: 'tier3',
};

export type HybridTierType = $Values<typeof HybridTiers>;

export const TIER1_CLOSEUP_MODAL_PERIOD = 5; // no hard limit on tier1, show modal every X closeups
export const TIER2_CLOSEUP_MODAL_LIMIT = 2;
export const TIER3_CLOSEUP_MODAL_LIMIT = 1;

export const TIER1_COUNTRIES: Set<string> = new Set(['AU', 'US', 'CA', 'IE', 'NZ', 'GB']);
export const TIER2_COUNTRIES: Set<string> = new Set([
  'AT',
  'BE',
  'CH',
  'CZ',
  'DK',
  'ES',
  'NO',
  'PT',
  'SE',
  'NL',
]);

// Timeout set to one minute
export const LOGIN_SIGNUP_MODAL_COOLDOWN_SECONDS = 60;

export const SHOWN_LOGIN_MODAL_IN_OPEN_COOLDOWN = 12;
